<mat-sidenav-container
  [autosize]="!isHandset()"
  [style.--app-sidebar-width]="isSidebarCollapsed() && !isHandset() ? '5.5rem' : '17rem'"
  class="sidenav-container"
>
  <mat-sidenav
    #drawer
    (transitionend)="onSidebarTransitionEnd($event)"
    [attr.role]="isHandset() ? 'dialog' : 'navigation'"
    [class.sidenav--collapsed]="isSidebarCollapsed() && !isHandset()"
    [disableClose]="isSidebarNonClosable()"
    [mode]="isHandset() ? 'over' : 'side'"
    [opened]="!isHandset()"
    class="sidenav"
    fixedInViewport
  >
    <div
      [class.side-navigation--collapsed]="isSidebarCollapsed() && !isHandset()"
      class="side-navigation hide-scrollbars"
    >
      <div
        class="side-navigation__user-info flex-initial p-5 pb-4"
        [class]="isSidebarCollapsed() && !isHandset() ? 'px-3' : 'pl-6 pr-6'"
      >
        <div class="side-navigation__user-info-row flex items-center">
          <hypecast-admin-user-info
            [isCollapsed]="isSidebarCollapsed() && !isHandset()"
            [showTenantOnly]="true"
            class="side-navigation__user-info-content"
          />
          @if (!isHandset()) {
            <button
              (click)="toggleSidebarCollapsed()"
              [attr.aria-label]="isSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
              [attr.title]="isSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
              class="side-navigation__collapse-btn"
              type="button"
            >
              <mat-icon class="side-navigation__collapse-icon" svgIcon="sidebar-collapse" />
            </button>
          }
        </div>
      </div>

      <div
        class="side-navigation__navigation flex-auto pt-6 pb-6"
        [class]="isSidebarCollapsed() && !isHandset() ? 'px-3' : 'p-5'"
      >
        <hypecast-admin-navigation [isCollapsed]="isSidebarCollapsed() && !isHandset()" />
      </div>

      <div
        class="side-navigation__lifecycle bottom"
        [class]="isSidebarCollapsed() && !isHandset() ? 'px-3' : 'pl-6 pr-6'"
      >
        <hypecast-admin-tenant-lifecycle-banner [collapsed]="isSidebarCollapsed() && !isHandset()" />
      </div>

      <div class="side-navigation__actions p-4" [class]="isSidebarCollapsed() && !isHandset() ? 'px-3' : 'pl-6 pr-6'">
        <hypecast-admin-actions [isCollapsed]="isSidebarCollapsed() && !isHandset()" />
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div [class.content-height-100vh]="vh100ContentSection()" class="bg-white pl-12 pt-9 pr-12">
      @if (isHandset()) {
        <button (click)="drawer.toggle()" aria-label="Toggle sidenav" mat-icon-button type="button">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
      }
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
